import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {breakpointDown} from '../utils/breakpoints'
import {Swiper} from "swiper";
import {Navigation, Pagination} from "swiper/modules";

gsap.registerPlugin(ScrollTrigger)
let $body = $('body')


function init() {

  if (breakpointDown('lg')) return false
  if (!document.querySelector('.block-logos')) return false

  gsap.fromTo('.js-first-logos-row', {x: '50%'}, {
    x: 0,
    scrollTrigger: {
      trigger: '.block-logos',
      start: 'top bottom',
      end: 'center+=15% center+=15%',
      scrub: true
    },
  });
  gsap.fromTo('.js-second-logos-row', {x: '-50%'}, {
    x: 0,
    scrollTrigger: {
      trigger: '.block-logos',
      start: 'top bottom',
      end: 'center+=15% center+=15%',
      scrub: true
    },
  });


// Drawing border hover animation
  $(window).on('load', function () {

    window.initLogoAnimations();

  })

  $body.on('mouseenter', '.js-hover-border-c', function () {
    let svg = $(this).find('.hover-border')
    let hoverVal = svg.attr('data-hover')
    svg.css({strokeDashoffset: hoverVal})
  })
  $body.on('mouseleave', '.js-hover-border-c', function () {
    let svg = $(this).find('.hover-border')
    let hoverVal = svg.attr('data-default')
    svg.css({strokeDashoffset: hoverVal})
  })
}

window.initLogoAnimations = () => {
  $('.js-hover-border-c').removeAttr('style');
  $('.js-hover-border-c').each(function () {
    let btnWidth = parseInt($(this).outerWidth())
    let btnHeight = parseInt($(this).outerHeight())
    let svg = $(this).find('.hover-border')
    let rect = svg.find('rect')

    svg.width(btnWidth)
    svg.height(btnHeight)
    $(this).width(btnWidth)
    $(this).height(btnHeight)

    let dashArray = btnWidth + btnHeight * 4
    let dashOffset = dashArray
    let dashOffsetHover = 0

    svg.attr('data-default', dashOffset)
    svg.attr('data-hover', dashOffsetHover)
    svg.attr('width', btnWidth)
    svg.attr('height', btnHeight)
    svg.css({strokeDasharray: `${dashArray}`, strokeDashoffset: `${dashOffset}`})
    rect.attr('width', btnWidth)
    rect.attr('height', btnHeight)

  })
}
let logoSwiper;
window.initLogoSwiper = () => {
  const block = $('.js--logo-swiper');
  if (!block.length) return false;

  if (logoSwiper) {
    logoSwiper.destroy(true, true); // Destroy Swiper instance
    logoSwiper = null; // Set swiper to null
    block.find('.swiper-slide').removeAttr('style');
    block.find('.swiper-wrapper').removeAttr('style');
  }

  if ($(window).width() < 744) {
    let sliderSwiper = document.querySelector('.js--logo-swiper')
    let nextBtn = sliderSwiper.querySelector('.swiper-nav-next')
    let prevBtn = sliderSwiper.querySelector('.swiper-nav-prev')


    logoSwiper = new Swiper('.js--logo-swiper', {
      modules: [Navigation, Pagination],
      spaceBetween: 20,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      loop: false,
      rewind: true,
    })
  }
};


init()
window.initLogoSwiper();
